import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "md:w-1/2" }
const _hoisted_2 = { class: "px-x3 py-x5 md:w-1/2 flex items-center" }

import { computed } from 'vue';
import { ProductDesignerTileModel } from '@/types/B2CcontentServerContract';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import dictionaryService from '@/core/dictionary/dictionary.service';
import { LinkViewModel } from '@/types/B2BcontentServerContract';
import TextBlockHandler from '@/shared/content/blocks/helpers/TextBlockHandler.vue';
import MediaHandler from '@/shared/content/blocks/helpers/MediaHandler.vue';
import { isReadable } from '@ctrl/tinycolor';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductDesignerTile',
  props: {
    content: null
  },
  setup(__props: any) {

const props = __props as { content: ProductDesignerTileModel }



const labels = useBlockLabels();

const labelNames = computed<{designer: string; country: string;}>(() => {
    return {
        designer: props.content.title,
        country: props.content.subTitle,
    };
});

const backgroundColor = computed<string>(() => {
    return props.content.backGroundColorHexCode || '#fff';
});

const title = computed<string>(() => {
    const labelName = props.content.subTitle ? labels.heading : labels.headingSimple;
    return dictionaryService.formatNamed(labelName, labelNames.value);
});

const link = computed<LinkViewModel>(() => {
    const linkText = dictionaryService.formatNamed(labels.seeMoreLinkText, labelNames.value);

    return {
        spaLink: props.content.link?.spaLink || false,
        target: '',
        text: linkText,
        title: linkText,
        url: props.content.link?.url || '',
    };
});

const invertTextColor = computed<boolean>(() => {
    return !!props.content.backGroundColorHexCode && !isReadable('#000', props.content.backGroundColorHexCode);
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", {
    class: "md:flex",
    style: _normalizeStyle({ 'background-color': _unref(backgroundColor) })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(MediaHandler, {
        "media-block": __props.content.media,
        "media-aspect-ratio": 1,
        "image-width-on-screen": { md: 50},
        "image-alt-text-override": __props.content.title
      }, null, 8, ["media-block", "image-alt-text-override"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(TextBlockHandler, {
        class: "lg:w-3/4 lg:m-auto",
        "invert-text-color": _unref(invertTextColor),
        title: _unref(title),
        text: __props.content.description,
        "link-url": _unref(link).url,
        "link-target": _unref(link).target,
        "link-text": _unref(link).text,
        "link-is-spa-link": _unref(link).spaLink
      }, null, 8, ["invert-text-color", "title", "text", "link-url", "link-target", "link-text", "link-is-spa-link"])
    ])
  ], 4))
}
}

})